export default __webpack_public_path__ + "static/media/regard_brulant.dd45ed81.jpg";